// extracted by mini-css-extract-plugin
export default {"iconMenuBtn":"RefreshOddania_iconMenuBtn__3EW2s","iconMenuBtnDisabled":"RefreshOddania_iconMenuBtnDisabled__1K5zw"};